import { Theme } from '@mui/material';

import { RentalFailedReason } from '~common/enum';
import { BAD_STATION_STATUS_PAGE_PATH, CountryItem } from '~configs';
import { StationStatus } from '~types/station.type';

export const DEFAULT_PRE_AUTH_AMOUNT = 1000;

export const DEFAULT_LANGUAGE_CODE = 'en-US';

export const TENANT_INFO_TIMEOUT_MS = 10000;

export const TENANT_INFO_FALLBACK_TIMEOUT_MS = 3000;

export const REDEEM_REWARD_INVALID_CODE = {
  // Referral
  INVALID_REFERRAL_CODE: 1018,
  REWARD_NOT_YET_AVAILABLE: 1020,
  REWARD_NOT_FOUND: 1017,
  // Promotion
  PROMOTION_NOT_YET_AVAILABLE: 1032,
  INVALID_PROMOTION_CODE: 1035,
};

export const ALREADY_REDEEM_REWARD_CODE = {
  // Referral
  REWARD_ALREADY_REDEEMED: 1019,
  // Promotion
  PROMOTION_ALREADY_REDEEMED: 1031,
  PROMOTION_USER_USAGE_REACH_LIMIT: 1034,
};

export const INPUT_BORDER_STYLES = {
  DEFAULT: '1px solid #DBDBDB',
  FOCUSED: '1px solid #3E8ABF',
  ERROR: '2px solid #B83031',
};

export const CARD_INPUT_BORDER_STYLES = {
  DEFAULT: '1px solid #DBDBDB',
  FOCUSED: (theme: Theme) => `2px solid ${theme.palette.brand.main}`,
  ERROR: '2px solid #B83031',
};

export const EJECT_BATTERY_BAD_STATUS_CODE = {
  STATION_OFFLINE: 1511,
  ALREADY_RENTED: 1405,
  PRE_AUTH_FAILED: 1414,
};

// redirect to bad status page based on the code
export const REDIRECT_BAD_STATUS_PAGE = {
  [EJECT_BATTERY_BAD_STATUS_CODE.STATION_OFFLINE]: `${BAD_STATION_STATUS_PAGE_PATH}/offline`,
  [EJECT_BATTERY_BAD_STATUS_CODE.ALREADY_RENTED]: `${BAD_STATION_STATUS_PAGE_PATH}/alreadyRented`,
  [RentalFailedReason.NO_RENTABLE_BATTERY]: `${BAD_STATION_STATUS_PAGE_PATH}/noChargersAvailable`,
  [StationStatus.RECHARGING]: `${BAD_STATION_STATUS_PAGE_PATH}/recharging`,
  [RentalFailedReason.STATION_OFFLINE]: `${BAD_STATION_STATUS_PAGE_PATH}/offline`,
  [RentalFailedReason.TIMED_OUT]: `${BAD_STATION_STATUS_PAGE_PATH}/issueEjecting`,
  [RentalFailedReason.FAILED_TO_INVOKE_IOT]: `${BAD_STATION_STATUS_PAGE_PATH}/issueEjecting`,
  [RentalFailedReason.STATION_CAN_NOT_EJECT_BATTERY]: `${BAD_STATION_STATUS_PAGE_PATH}/issueEjecting`,
};

export const FUZE_CASH = {
  FUZE_CASH_MAX_AMOUNT: 99999999,
  FUZE_CASH_MAX_AMOUNT_DISPLAY: '999,999.99+',
};

export const DEFAULT_COUNTRY_DATA: CountryItem = {
  name: 'United States',
  regions: ['america', 'north-america'],
  iso2: 'us',
  dialCode: '1',
  priority: 0,
  format: '+. (...) ...-....',
};

export const DEFAULT_PHONE_FORMAT = '... ... ... ... ...';

export const DEVICE_ID_PREFIX = 'webapp-';
